import {
  type PropsWithChildren,
  type ReactNode,
  useEffect,
  useRef,
} from "react";

interface OutsideClickProps {
  handleClickOutside: (event: PointerEvent) => void;
  children: ReactNode;
}

function OutsideClick({
  handleClickOutside,
  children,
}: PropsWithChildren<OutsideClickProps>) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      const target = event.target;
      if (target instanceof Node && !containerRef.current?.contains(target)) {
        handleClickOutside(event);
      }
    };

    // One pointerdown listener covers mouse, touch, and pen. Listening to both
    // mousedown and touchstart made a phone tap fire twice: the first event
    // unmounted the overlay, and the compatibility mouse event could then click
    // through to whatever was behind the dialog.
    document.addEventListener("pointerdown", handlePointerDown);

    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [handleClickOutside]);

  return (
    <div ref={containerRef} style={{ display: "contents" }}>
      {children}
    </div>
  );
}

export default OutsideClick;
